import {
    ADD_AVAILABLE_UNITS_REQUEST,
    ADD_AVAILABLE_UNITS_SUCCESS,
    ADD_AVAILABLE_UNITS_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_SUCCESS,
    GET_AVAILABLE_UNITS_FAILURE,
    GET_AVAILABLE_UNITS_LIST_REQUEST,
    GET_AVAILABLE_UNITS_LIST_SUCCESS,
    GET_AVAILABLE_UNITS_LIST_FAILURE,
    REMOVE_AVAILABLE_UNITS_SUCCESS,
    REMOVE_AVAILABLE_UNITS_FAILURE,
    EDIT_AVAILABLE_UNITS_SUCCESS,
    EDIT_AVAILABLE_UNITS_FAILURE
} from './constants';

const initialState = {
    loading: false,
    data: [],
    added: undefined,
    edited: undefined,
    deleted: undefined,
    changeDate: true,
    getOne: undefined,
    hideModal: false,
    numberOfUnits: 0,
    validationStatus: false,
    validationMessage: ''
};

const adminAvailableUnitsReducer = (state = initialState, action) => {
    var message;
    switch (action.type) {
        case ADD_AVAILABLE_UNITS_REQUEST: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading: false, added: undefined, validationStatus: false, validationMessage: ''});
        }
        case ADD_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: true, loading: false, added: true, data: action.data, validationStatus: false, validationMessage: ''});
        }
        case ADD_AVAILABLE_UNITS_FAILURE: {
            message = (action.data.type === 'VALIDATION_ERROR') ? action.data.validationErrors.error[0] : action.data.message;
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: true, loading: false, added: false, validationStatus: true, validationMessage: message});
        }
        case GET_AVAILABLE_UNITS_REQUEST: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading: false, added: undefined, changeDate: false, getOne: false, validationStatus: false, validationMessage: ''});
        }
        case GET_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading: false, added: undefined, changeDate: true, getOne: true, numberOfUnits: action.data, validationStatus: false, validationMessage: ''});
        }
        case GET_AVAILABLE_UNITS_FAILURE: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading: false, added: undefined, changeDate: true, getOne: true, numberOfUnits: 0, validationStatus: false, validationMessage: ''});
        }
        case GET_AVAILABLE_UNITS_LIST_REQUEST: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading:false, availableListLoading: true, added: undefined, changeDate: true, getOne: undefined, validationStatus: false, validationMessage: ''});
        }
        case GET_AVAILABLE_UNITS_LIST_SUCCESS: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading:false, availableListLoading: false, added: undefined, changeDate: true , getOne: undefined,  data: action.data.units, numberOfUnits: action.data.numberOfUnits, validationStatus: false, validationMessage: ''});
        }
        case GET_AVAILABLE_UNITS_LIST_FAILURE: {
            return Object.assign({}, state, {deleted: undefined, edited: undefined, hideModal: false, loading:false, availableListLoading: false, added: undefined, changeDate: true, getOne: undefined, data: [], numberOfUnits: 0, validationStatus: false, validationMessage: ''});
        }
        case REMOVE_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {deleted: true, edited: undefined, hideModal: false, loading: false, added: undefined, changeDate: true, getOne: undefined, data: action.data.units, numberOfUnits: action.data.numberOfUnits, validationStatus: false, validationMessage: ''});
        }
        case REMOVE_AVAILABLE_UNITS_FAILURE: {
            return Object.assign({}, state, {deleted: false, edited: undefined, hideModal: false, loading: false, added: undefined, changeDate: true,getOne: undefined, numberOfUnits: 0, validationStatus: false, validationMessage: ''});
        }
        case EDIT_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {deleted: undefined, edited: true, hideModal: false, loading: false, added: undefined, changeDate: true, getOne: undefined, data: action.data.units, numberOfUnits: action.data.numberOfUnits, validationStatus: false, validationMessage: ''});
        }
        case EDIT_AVAILABLE_UNITS_FAILURE: {
            message = (action.data.type === 'VALIDATION_ERROR') ? action.data.validationErrors.error[0] : action.data.message;
            return Object.assign({}, state, {deleted: undefined, edited: false, hideModal: false, loading: false, added: undefined, changeDate: true,  getOne: undefined, numberOfUnits: 0, validationStatus: true, validationMessage: message});
        }
        default: {
            return state;
        }
    }
};

export default adminAvailableUnitsReducer;


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AvailableUnits/reducer.js